import { useIntl } from 'react-intl';
import { forwardRef } from '@chakra-ui/react';

import { Table } from '../../Table';
import { type RowProps } from '../../Table/parts';
import { useFees } from '../context';

export type CardPayoutEuroProps = RowProps;

export const CardPayoutEuro = forwardRef<CardPayoutEuroProps, 'div'>(
  (props, ref) => {
    const intl = useIntl();
    const { fees, toFixed, toVariable } = useFees();

    const locales = {
      label: intl.formatMessage({
        id: 'subscription.fees_modal.card_payout_euro.label',
      }),
      value: intl.formatMessage(
        {
          id: 'subscription.fees_modal.card_payout_euro.value',
        },
        {
          fixed: toFixed(fees.cardPayoutEuro),
          variable: toVariable(fees.cardPayoutEuro),
        },
      ),
    };

    return (
      <Table.Row {...props} ref={ref}>
        <Table.CellText>{locales.label}</Table.CellText>
        <Table.CellAmount>{locales.value}</Table.CellAmount>
      </Table.Row>
    );
  },
);
